import React, { useRef, useState, useEffect } from 'react';
import A11yDialog from 'a11y-dialog';
import { fetchHolidayDepartures } from '../../../modules/api';

const ButtonBerndDatesPrices = ({
  classes = '',
  inactiveTitle = 'Enquire Now',
  activeTitle = 'Dates and Prices',
  holidayId,
  contactLink,
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const dialogInstanceRef = useRef(null);

  // Helper functions
  const openDatesAndPricesDialog = () => {
    if (dialogInstanceRef.current) {
      dialogInstanceRef.current.show();
    } else {
      console.error('Dialog instance is not available');
    }
  };

  // Hooks
  useEffect(() => {
    // Pull in the dialog instance from the DOM of the parent page and assign to the ref as
    // an A11yDialog item so .show() method can be used on it by openDatesAndPricesDialog()
    const dialogElement = document.getElementById('dates-prices-dialog');
    if (dialogElement) {
      dialogInstanceRef.current = new A11yDialog(dialogElement);
    }

    return () => {
      if (dialogInstanceRef.current) {
        dialogInstanceRef.current.destroy();
        dialogInstanceRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const departures = await fetchHolidayDepartures(holidayId);
        setItems(departures);
      } catch (error) {
        console.error('Can not get holiday departures feed', error);
      } finally {
        setLoading(false);
      }
    })();
  }, [holidayId]);

  return (
    <span>
      {loading ? (
        <span className={classes}>Loading...</span>
      ) : Array.isArray(items) && items.length ? (
        <a
          href="#"
          className={classes}
          onClick={(e) => {
            e.preventDefault();
            openDatesAndPricesDialog();
          }}
        >
          {activeTitle}
        </a>
      ) : (
        <a className={classes} href={contactLink}>
          {inactiveTitle}
        </a>
      )}
    </span>
  );
};

export default ButtonBerndDatesPrices;
